// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/components/PartnerGrid.tsx
// Version: v1.0.1
// Description: Partner-Logo-Grid mit Swiper Carousel
import React from "react";
import { Link } from "react-router-dom"; // ← NEU!
import { useBreakpoints } from "../hooks/Breakpoints.tsx";
import Container from "../hooks/Container.tsx";
import Button from "../components/ui/Button.tsx";

const logos = [
  "partner_logos/Cushman_Wakefield_logo.png",
  "partner_logos/BlackRock-logo.png",
  "partner_logos/Shore-Capital.png",
  "partner_logos/CBRE_Group_logo.png",
  "partner_logos/HOWOGE_Logo.png",
  "partner_logos/BIM_Logo.png",
  "partner_logos/accentro.png",
  "partner_logos/smava_logo.png",
  "partner_logos/BlueRock-logo.png",
];

const PartnerGrid: React.FC = () => {
  const { current } = useBreakpoints();
  const isMobile = current === "mobile";
  const isTablet = current === "tablet";
  const isDesktop = current === "desktop";

  let rows: string[][] = [];

  if (isDesktop) {
    rows = [logos.slice(0, 4), logos.slice(4, 8)];
  } else if (isTablet) {
    rows = [logos.slice(0, 3), logos.slice(3, 6), logos.slice(6, 9)];
  } else {
    rows = [
      logos.slice(0, 2),
      logos.slice(2, 4),
      logos.slice(4, 6),
      logos.slice(6, 8),
    ];
  }

  const textSize = isDesktop ? "text-7xl" : isTablet ? "text-5xl" : "text-4xl";
  const logoSize = isDesktop ? "w-[12rem]" : isTablet ? "w-[9rem]" : "w-[8rem]";
  
  return (
    <section className={`bg-black text-white mb-[150px] md:mb-[150px] lg:mb-[300px]`}>
      <Container>
        {/* Headline */}
        <div className="flex justify-between items-center mb-16 flex-wrap gap-4">
          <h2 className={`font-bold ${textSize}`}>50+ partnerships</h2>
          
          {/* ✅ FIXED: Link-Component für Client-Side Routing */}
          <Link to="/partners">
            <Button size="M" variant="bordered">
              View all partners
            </Button>
          </Link>
        </div>

        {/* Logos nach Zeile */}
        <div className="flex flex-col gap-y-20">
          {rows.map((row, rowIndex) => (
            <div
              key={rowIndex}
              className={
                isMobile
                  ? "grid grid-cols-2 gap-x-6 px-[min(5vw,1.5rem)]"
                  : "flex justify-between"
              }
            >
              {row.map((logo, logoIndex) => (
                <div
                  key={logoIndex}
                  className="flex justify-center items-center"
                >
                  <img
                    src={`/images/${logo}`}
                    alt={`Partner ${rowIndex * row.length + logoIndex + 1}`}
                    className={`${logoSize} h-auto object-contain`}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default PartnerGrid;